/**
 * @file
 */

export function InitializeContactUsPage() {
    $("#DivPSLFSMDisclaimer").dialog({
        dialogClass: "PSLFSMDialog",
        modal: true,
        autoOpen: false,
        title: "",
        width: "50%",
        maxWidth: 250,
        resizable: false,
        position: { my: "center", at: "center", of: window },
        buttons: [
            {
                id: "btnOK",
                text: "OK",
                click: function () {
                    handleSendSecureMessage();
                    $(this).dialog('close');
                }
            },
            {
                id: "btnCancel",
                text: "Cancel",
                click: function () {
                    $(this).dialog('close');
                }
            }
        ]
    });



   // --------------------------------------------------------------------------
   // define click-event for the send secure message link
   // when clicked, this routine will determine what FAQ was selected
   //  and pass that as a query string so that the subject of the
   //  of the secure message can be set to that topic.
   // --------------------------------------------------------------------------
   $('.sendSecureMessage').click(function(e){
       var selectedVal = $('.topicDDL :selected').val() as string | string[];

       e.preventDefault();

       if (selectedVal.includes("224")) {
          $("#DivPSLFSMDisclaimer").dialog('open');
       } else {
          handleSendSecureMessage();
       }

       return false;
   });

  $("#divSecureMessageDisclaimer").dialog({
    dialogClass: "SecureMessageDialog",
    modal: true,
    autoOpen: false,
    title: "",
    width: "70%",
    maxWidth: 500,
    resizable: false,
    position: { my: "center", at: "center", of: window }
  });

  $('.sendSecureMessageMohela').click(function (e) {
    $('#divSecureMessageDisclaimer').dialog('open');
    return false;
  });

   $("[id$='ddlPaymentRegion']").change(function (e) {
      var ddlPaymentRegion_value = $("[id$='ddlPaymentRegion'] option:selected").val();
      var divPaymentDL = $("[id$='divPaymentDL']");
      var divPaymentFFELP = $("[id$='divPaymentFFELP']");

      if (ddlPaymentRegion_value == "D") {
         divPaymentDL.removeClass("ui-helper-hidden");
         if (!divPaymentFFELP.hasClass("ui-helper-hidden")) {
            divPaymentFFELP.addClass("ui-helper-hidden");
         }
      } else if (ddlPaymentRegion_value == "F") {
         divPaymentFFELP.removeClass("ui-helper-hidden");
         if (!divPaymentDL.hasClass("ui-helper-hidden")) {
            divPaymentDL.addClass("ui-helper-hidden");
         }
      } else {
         if (!divPaymentDL.hasClass("ui-helper-hidden")) {
            divPaymentDL.addClass("ui-helper-hidden");
         }
         if (!divPaymentFFELP.hasClass("ui-helper-hidden")) {
            divPaymentFFELP.addClass("ui-helper-hidden");
         }
      }


   });

  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.SecureMessageDisclaimerClose = SecureMessageDisclaimerClose;
  // @ts-ignore Hack for aspx page direct use -- A.M. 2025-09-08
  window.SecureMessageDisclaimerContinue = SecureMessageDisclaimerContinue;
};

function handleSendSecureMessage() {
  var selectedValueParts = [];
  var selectedText = $('.topicDDL :selected').text();
  var selectedVal = $('.topicDDL :selected').val() as string;
  selectedValueParts = selectedVal.split('_');
  var subjectsendflag = selectedValueParts[0];
  var subjectkey = selectedValueParts[1];
  var subjectsendto = selectedValueParts[2];

  if ($("[id$='hdnDDLstate']").val() == 'IL') {
    var redirectUrl = location.origin + '/DL/secure/messages/GPLRfaInfoGet.aspx?CuSubjectKey=' + subjectkey;
  }
  else {
    var redirectUrl = location.origin + '/DL/secure/messages/GPLSendSecureEmail.aspx?CuSubjectKey=' + subjectkey;
  }

  // ---------------------------------------------------------------------------------------------
  // make ajax call to create session variable for nextpage so that if borrower has to login, 
  // they will get a custom message on the loginstep1 page
  // N.B. this is only needed for send a message because the IL Law does not require login
  //      and if no login account, the request for information page will send the message
  // ---------------------------------------------------------------------------------------------
  if (subjectsendto == 'SM') {
    CuSetNextPage();
  }

  window.location.href = redirectUrl;
}


function SecureMessageDisclaimerClose() {
  $('#divSecureMessageDisclaimer').dialog('close');
  return false;
}

function SecureMessageDisclaimerContinue() {
  handleSendSecureMessage();
  return false;
}


// -----------------------------------------------------------------------------
//  use ajax to set a session variable from javascript
//   login custom messages are created based upon a next page session variable.
//   this routine calls the code behind routine on the contact us page to
//   set the session variable based upon the topic selected.
// -----------------------------------------------------------------------------
function CuSetNextPage() {
   $.ajax({
      type: "POST",
      url: "ContactUs.aspx/CuSetNextPage",
      data: '',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      async: false
   });
   return true;
}
